//Ajouter Declarations

import React, { useState, useEffect } from "react";
import { Container, Typography, Select, MenuItem, Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import '../CSS/ajouterdeclarations.css';
import axios from 'axios';
import apiUrl from '../config'; // Assure-toi que ton apiUrl est bien importé
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { CircularProgress } from '@mui/material';
import LayoutDashboard from '../layout/LayoutDashboard';

const AjouterDeclarations = () => {
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [workDays, setWorkDays] = useState({});
    const [leaveDays, setLeaveDays] = useState({});
    const [isDragging, setIsDragging] = useState(false);
    const [currentType, setCurrentType] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);  // ✅ Ajouté ici
    const [declarationId, setDeclarationId] = useState(null);    // ✅ Ajouté ici
    const navigate = useNavigate();
    const location = useLocation();
    const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });
    const [loading, setLoading] = useState(false);
    const [loadingEditView, setLoadingEditView] = useState(false); // 🔄 nouveau
    const [blockedDaysMap, setBlockedDaysMap] = useState({});
    const [isDaysLoading, setIsDaysLoading] = useState(false);
    const [monthAlreadyDeclared, setMonthAlreadyDeclared] = useState(false);

    


    useEffect(() => {
        const fetchDeclarationDetails = async () => {
            if (location.state) {
                // ✅ Définit l'utilisateur sélectionné passé depuis Declarations.js
                if (location.state.selectedUserId) {
                    setSelectedUserId(location.state.selectedUserId);
                }
    
                if (location.state.declarationId) {
                    setIsEditMode(true);
                    setDeclarationId(location.state.declarationId);
                    setLoadingEditView(true);
    
                    try {
                        const token = localStorage.getItem('token');
                        const response = await axios.get(`${apiUrl}/declarations/details/${location.state.declarationId}`, {
                            headers: { Authorization: `Bearer ${token}` }
                        });
    
                        if (response.status === 200) {
                            const declaration = response.data;
    
                            // Jours travail
                            const workDaysArray = declaration.Jours_Selectionnes.split("/  ").map(date => date.trim()).filter(Boolean);
const leaveDaysArray = declaration.jours_congé.split("/  ").map(date => date.trim()).filter(Boolean);
const workDaysObject = {};
const leaveDaysObject = {};

// D'abord, remplis les deux objets normalement
workDaysArray.forEach(date => {
    const day = new Date(date).getDate();
    workDaysObject[day] = 1;
});
leaveDaysArray.forEach(date => {
    const day = new Date(date).getDate();
    leaveDaysObject[day] = 1;
});

// Puis, détecte les jours communs et mets à jour à 0.5 / 0.5
Object.keys(workDaysObject).forEach(day => {
    if (leaveDaysObject[day]) {
        workDaysObject[day] = 0.5;
        leaveDaysObject[day] = 0.5;
    }
});

setWorkDays(workDaysObject);
setLeaveDays(leaveDaysObject);
    
                            // Mois + Année
                            const firstDate = new Date(workDaysArray[0] || leaveDaysArray[0]);
                            setSelectedMonth(firstDate.getMonth() + 1);
                            setSelectedYear(firstDate.getFullYear());
    
                            // ✅ Assure que l'utilisateur cible est pris depuis la déclaration uniquement si pas déjà transmis
                            if (!location.state.selectedUserId) {
                                setSelectedUserId(declaration.Id_Utilisateur);
                            }
                        }
                    } catch (error) {
                        console.error('Erreur lors du chargement de la déclaration :', error);
                    } finally {
                        setLoadingEditView(false);
                }
            }
            
         }
      };
    
        fetchDeclarationDetails();
    }, [location.state]);


    useEffect(() => {
  if (!selectedUserId) {
    let finalId = null;

    // 1. Vérifie si on a un userId transmis depuis la navigation
    if (location.state?.selectedUserId) {
      finalId = location.state.selectedUserId;
    } else {
      // 2. Sinon, essaie de récupérer depuis le token
      try {
        const token = localStorage.getItem('token');
        if (token) {
          const decoded = JSON.parse(atob(token.split('.')[1]));
          finalId = decoded.user_id;
        }
      } catch {}
    }

    if (finalId) {
      setSelectedUserId(finalId); // 🔥 Défini UNE seule fois
      
    }
  }
}, [selectedUserId, location.state]);


    
useEffect(() => {
  if (selectedMonth && selectedYear && selectedUserId) {
    handleMonthChange(selectedMonth, selectedUserId);
  }
}, [selectedUserId, selectedMonth, selectedYear]);


    

// 👇 Normalise l'ID utilisateur (accepte nombre, string, ou objet)
const normalizeUserId = (raw) => {
  if (raw == null) return null;
  if (typeof raw === 'object') return raw.id || raw.Id_Utilisateur || null;
  return raw; // nombre ou string OK
};

const getBlockedDaysCacheKey = (userId, month, year) => {
  return `blocked_declaration_days_${userId}_${month}_${year}`;
};

const getCachedBlockedDays = (userId, month, year) => {
  try {
    const cached = sessionStorage.getItem(getBlockedDaysCacheKey(userId, month, year));
    return cached ? JSON.parse(cached) : null;
  } catch {
    return null;
  }
};

const saveCachedBlockedDays = (userId, month, year, data) => {
  sessionStorage.setItem(
    getBlockedDaysCacheKey(userId, month, year),
    JSON.stringify(data)
  );
};

const clearBlockedDaysCache = (userId, month, year) => {
  sessionStorage.removeItem(getBlockedDaysCacheKey(userId, month, year));
};
    
   // ✅ REMPLACER ces 2 handlers par ceci
const handleMonthChange = async (input, userIdOverride = null, joursExistants = null) => {
  const month = typeof input === 'number' ? input : parseInt(input.target.value);

  if (!isEditMode) {
    setSelectedMonth(month);
  }

  setIsDaysLoading(true);

  // 🟢 Toujours utiliser normalizeUserId
  const validUserId = normalizeUserId(
    userIdOverride || location.state?.selectedUserId || selectedUserId
  );

  

  if (!validUserId || !selectedYear || !month) {
    console.warn("handleMonthChange bloqué : ID, année ou mois manquant", { validUserId, selectedYear, month });
    setIsDaysLoading(false);
    return;
  }

  try {
    const token = localStorage.getItem('token');
    const jours = { ...workDays, ...leaveDays };

const response = await axios.get(
  `${apiUrl}/declarations/jours-bloques/${validUserId}/${month}/${selectedYear}?t=${Date.now()}`,
  { headers: { Authorization: `Bearer ${token}` } }
);

const joursBloques = response.data || [];

if (!isEditMode && Array.isArray(joursBloques) && joursBloques.length > 0) {
  const allDaysBlocked = {};
  const totalDays = new Date(selectedYear, month, 0).getDate();

  for (let day = 1; day <= totalDays; day++) {
    allDaysBlocked[day] = "bloqué";
  }

  setWorkDays({});
  setLeaveDays({});
  setBlockedDaysMap(allDaysBlocked);
  setMonthAlreadyDeclared(true);

  setNotification({
    open: true,
    message: "Ce mois est déjà déclaré. Pour ajouter ou corriger des jours, passez par Modifier.",
    severity: "warning"
  });

  return;
}

setMonthAlreadyDeclared(false);

for (const jour of joursBloques) {
  if (!(jour in jours)) {
    jours[jour] = "bloqué";
  }
}

    setBlockedDaysMap(jours);

  } catch (error) {
    console.error("❌ Erreur lors du chargement des jours bloqués :", error);
  } finally {
    setIsDaysLoading(false);
  }
};




const handleYearChange = (e) => {
  const year = parseInt(e.target.value, 10);

  setSelectedYear(year);
  setWorkDays({});
  setLeaveDays({});
  setBlockedDaysMap({});
};


    const getDaysInMonth = (year, month) => {
        const daysInMonth = new Date(year, month, 0).getDate();
        return Array.from({ length: daysInMonth }, (_, i) => i + 1);
    };
    

    const toggleDay = (day, type) => {
        if (blockedDaysMap[day] === "bloqué") return;
        const isWork = workDays[day];
        const isLeave = leaveDays[day];
    
        if (type === "work") {
            if (isWork === 1) {
                const newWorkDays = { ...workDays };
                delete newWorkDays[day];
                setWorkDays(newWorkDays);
            } else if (isWork === 0.5 && isLeave === 0.5) {
                // Désélectionne travail → congé passe à 1
                const newWorkDays = { ...workDays };
                const newLeaveDays = { ...leaveDays, [day]: 1 };
                delete newWorkDays[day];
                setWorkDays(newWorkDays);
                setLeaveDays(newLeaveDays);
            } else if (isLeave === 1) {
                setWorkDays({ ...workDays, [day]: 0.5 });
                setLeaveDays({ ...leaveDays, [day]: 0.5 });
            } else {
                setWorkDays({ ...workDays, [day]: 1 });
            }
        }
    
        if (type === "leave") {
            if (isLeave === 1) {
                const newLeaveDays = { ...leaveDays };
                delete newLeaveDays[day];
                setLeaveDays(newLeaveDays);
            } else if (isLeave === 0.5 && isWork === 0.5) {
                // Désélectionne congé → travail passe à 1
                const newLeaveDays = { ...leaveDays };
                const newWorkDays = { ...workDays, [day]: 1 };
                delete newLeaveDays[day];
                setLeaveDays(newLeaveDays);
                setWorkDays(newWorkDays);
            } else if (isWork === 1) {
                setWorkDays({ ...workDays, [day]: 0.5 });
                setLeaveDays({ ...leaveDays, [day]: 0.5 });
            } else {
                setLeaveDays({ ...leaveDays, [day]: 1 });
            }
        }
    };
    

    const handleSubmit = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('token');
            const formattedWorkDays = Object.keys(workDays)
                .filter(day => workDays[day])
                .map(day => new Date(selectedYear, selectedMonth - 1, day).toLocaleDateString('fr-CA'));
            const formattedLeaveDays = Object.keys(leaveDays)
                .filter(day => leaveDays[day])
                .map(day => new Date(selectedYear, selectedMonth - 1, day).toLocaleDateString('fr-CA'));
    
            const payload = {
                workDays: formattedWorkDays,
                leaveDays: formattedLeaveDays,
                Id_Utilisateur: selectedUserId
            };
    
            const response = await axios.post(`${apiUrl}/declarations`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            });
    
            if (response.status === 201) {
                setNotification({ open: true, message: 'Déclaration ajoutée avec succès.', severity: 'success' });
                sessionStorage.clear();
               navigate('/Déclarations', {
  replace: true,
  state: {
    selectedUserId: normalizeUserId(selectedUserId),
    refreshKey: Date.now()
  }
});
            }
        } catch (error) {
    console.error("Erreur lors de l'ajout :", error);

    if (error.response?.status === 409) {
        setNotification({
            open: true,
            message: error.response.data.message,
            severity: 'warning'
        });
        return;
    }

    setNotification({
        open: true,
        message: "Erreur lors de l'ajout.",
        severity: 'error'
    });
} finally {
    setLoading(false);
}
    };     

    const handleUpdate = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('token');
            const formattedWorkDays = Object.keys(workDays)
                .filter(day => workDays[day])
                .map(day => new Date(selectedYear, selectedMonth - 1, day).toLocaleDateString('fr-CA'));
            const formattedLeaveDays = Object.keys(leaveDays)
                .filter(day => leaveDays[day])
                .map(day => new Date(selectedYear, selectedMonth - 1, day).toLocaleDateString('fr-CA'));
    
            const payload = {
                workDays: formattedWorkDays,
                leaveDays: formattedLeaveDays,
                Id_Utilisateur: selectedUserId
            };
    
            const response = await axios.put(`${apiUrl}/declarations/${declarationId}`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            });
    
            if (response.status === 200) {
              sessionStorage.clear();
                setNotification({ open: true, message: 'Déclaration modifiée avec succès.', severity: 'success' });
                navigate('/Déclarations', {
  replace: true,
  state: {
    selectedUserId,
    refreshKey: Date.now()
  }
});
            }
        } catch (error) {
            console.error("Erreur lors de la mise à jour :", error);
            setNotification({ open: true, message: "Erreur lors de la mise à jour.", severity: 'error' });
        } finally {
            setLoading(false);
        }
    };
    

    const handleMouseDown = (day, type) => {
        setIsDragging(true);
        setCurrentType(type);
        toggleDay(day, type);
    };

    const handleMouseOver = (day) => {
        if (isDragging && currentType) {
            toggleDay(day, currentType);
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
        setCurrentType(null);
    };

    const getFrenchHolidays = (year) => {
        const holidays = new Set([
            `${year}-01-01`, // Nouvel An
            `${year}-05-01`, // Fête du Travail
            `${year}-05-08`, // Victoire 1945
            `${year}-07-14`, // Fête Nationale
            `${year}-08-15`, // Assomption
            `${year}-11-01`, // Toussaint
            `${year}-11-11`, // Armistice
            `${year}-12-25`  // Noël
        ]);
    
        // Calcul de Pâques
        const a = year % 19;
        const b = Math.floor(year / 100);
        const c = year % 100;
        const d = Math.floor(b / 4);
        const e = b % 4;
        const f = Math.floor((b + 8) / 25);
        const g = Math.floor((b - f + 1) / 3);
        const h = (19 * a + b - d - g + 15) % 30;
        const i = Math.floor(c / 4);
        const k = c % 4;
        const l = (32 + 2 * e + 2 * i - h - k) % 7;
        const m = Math.floor((a + 11 * h + 22 * l) / 451);
        const month = Math.floor((h + l - 7 * m + 114) / 31);
        const day = ((h + l - 7 * m + 114) % 31) + 1;
    
        const easter = new Date(year, month - 1, day);
        const easterMonday = new Date(easter);
        easterMonday.setDate(easter.getDate() + 1);
        const ascensionDay = new Date(easter);
        ascensionDay.setDate(easter.getDate() + 39);
        const pentecostMonday = new Date(easter);
        pentecostMonday.setDate(easter.getDate() + 50);
    
        holidays.add(easter.toLocaleDateString('fr-CA'));
        holidays.add(easterMonday.toLocaleDateString('fr-CA'));
        holidays.add(ascensionDay.toLocaleDateString('fr-CA'));
        holidays.add(pentecostMonday.toLocaleDateString('fr-CA'));
    
        return holidays;
    };
    
    
    const holidays = getFrenchHolidays(selectedYear);
    
    const isHoliday = (day, month, year, holidays) => {
        if (!month || !year) return false;
        const date = new Date(year, month - 1, day);  // Mois indexé de 0 à 11
        const formattedDate = date.toLocaleDateString('fr-CA');  // Format en 'YYYY-MM-DD'
        return holidays.has(formattedDate);
    };
    
    const isWeekend = (day, month, year) => {
        const date = new Date(year, month - 1, day);
        const dayOfWeek = date.getDay();
        return dayOfWeek === 0 || dayOfWeek === 6; // Dimanche = 0, Samedi = 6
    };

    
    const daysInMonth = selectedMonth ? getDaysInMonth(selectedYear, selectedMonth) : [];

    const isToday = (day, month, year) => {
        const today = new Date();
        return (
          day === today.getDate() &&
          month === today.getMonth() + 1 &&
          year === today.getFullYear()
        );
      };

    
  


    return (
      <LayoutDashboard>
    <div className="declarations-add-page" onMouseUp={handleMouseUp}>
        <Container maxWidth="lg" sx={{ p: 0 }}>
                <div className="header">
                    <Typography variant="h1" gutterBottom align="center" sx={{ color: '#FFFF', marginBottom: '10px' }}>
                        {isEditMode ? "Modifier une déclaration" : "Ajouter une déclaration"}
                    </Typography>
                </div>
                
                <div className="month-selector">
                    <Typography variant="h6" sx={{ color: '#0B349D' }}>Sélectionner le Mois et l'Année :</Typography>
                    <div className="select-row">
                        <Select
                            value={selectedMonth || ''}
                            onChange={handleMonthChange}
                            displayEmpty
                            variant="outlined"
                            fullWidth
                            sx={{ bgcolor: 'white', borderRadius: '4px' }}
                        >
                            <MenuItem value="" disabled>Choisir un mois</MenuItem>
                            {Array.from({ length: 12 }, (_, index) => (
                                <MenuItem key={index + 1} value={index + 1}>
                                    {new Date(0, index).toLocaleString('default', { month: 'long' })}
                                </MenuItem>
                            ))}
                        </Select>

                        <Select
                            value={selectedYear}
                            onChange={handleYearChange}
                            displayEmpty
                            variant="outlined"
                            fullWidth
                            sx={{ bgcolor: 'white', borderRadius: '4px' }}
                        >
                            {Array.from({ length: 5 }, (_, index) => {
                                const year = 2025 + index;
                                return (
                                    <MenuItem key={year} value={year}>
                                        {year}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </div>
                </div>

                {selectedMonth && isDaysLoading && (
  <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:12, minHeight:120 }}>
    <CircularProgress size={28} />
    <Typography>Chargement des jours déjà déclarés…</Typography>
  </div>
)}


                {selectedMonth && !isDaysLoading && (
    <div 
        className="table-wrapper" 
        style={{ 
            overflowX: 'auto', 
            whiteSpace: 'nowrap', 
            display: 'block', 
            maxWidth: '100%' // Assure que le défilement fonctionne bien
        }}
    >
        <table className="styled-table" style={{ tableLayout: 'fixed', width: '150%' }}>
            <thead>
                <tr>
                    <th className="main-column">Jours du Mois</th>
                    {daysInMonth.map(day => {
  const isCurrent = isToday(day, selectedMonth, selectedYear);
  return (
    <th
      key={day}
      className="day-column"
      style={{
        minWidth: '80px',
        backgroundColor: isCurrent ? '#fff2b3' : '', 
        color: isCurrent ? 'black' : '',
        fontWeight: isCurrent ? 'bold' : 'normal'
      }}
    >
      {day}
    </th>
  );
})}
                </tr>
            </thead>
            <tbody>
  {/* --- LIGNE TRAVAIL --- */}
  <tr>
    <td className="main-column">Jours de Travail</td>
    {daysInMonth.map(day => {
      const isGray = isWeekend(day, selectedMonth, selectedYear) || isHoliday(day, selectedMonth, selectedYear, holidays);
      const isBlocked = blockedDaysMap[day] === "bloqué";
      const isSelected = workDays[day] === 1;
      const isHalfDay = workDays[day] === 0.5 && leaveDays[day] === 0.5;

      return (
        <td
          key={`work-${day}`}
          onMouseDown={() => { if (!(isGray || isBlocked)) handleMouseDown(day, "work"); }}
          onMouseOver={() => { if (isDragging && currentType && !(isGray || isBlocked)) handleMouseOver(day); }}
          onMouseUp={handleMouseUp}
          title={isBlocked ? "Jour déjà déclaré (bloqué)" : ""}
          style={{
            backgroundColor: isGray || isBlocked
              ? '#D3D3D3'
              : isHalfDay
              ? '#9ecfff'
              : isSelected
              ? '#007bff'
              : '',
            cursor: (isGray || isBlocked) ? 'not-allowed' : 'pointer',
            minWidth: '80px',
            opacity: isBlocked ? 0.6 : 1,
            border: isBlocked ? '2px dashed #999' : undefined
          }}
        >
          {workDays[day] === 1 ? '1' : workDays[day] === 0.5 ? '0.5' : ''}
        </td>
      );
    })}
  </tr>

  {/* --- LIGNE CONGÉ --- */}
  <tr>
    <td className="main-column">Jours de Congé</td>
    {daysInMonth.map(day => {
      const isGray = isWeekend(day, selectedMonth, selectedYear) || isHoliday(day, selectedMonth, selectedYear, holidays);
      const isBlocked = blockedDaysMap[day] === "bloqué";
      const isSelected = leaveDays[day] === 1;
      const isHalfDay = workDays[day] === 0.5 && leaveDays[day] === 0.5;

      return (
        <td
          key={`leave-${day}`}
          onMouseDown={() => { if (!(isGray || isBlocked)) handleMouseDown(day, "leave"); }}
          onMouseOver={() => { if (isDragging && currentType && !(isGray || isBlocked)) handleMouseOver(day); }}
          onMouseUp={handleMouseUp}
          title={isBlocked ? "Jour déjà déclaré (bloqué)" : ""}
          style={{
            backgroundColor: isGray || isBlocked
              ? '#D3D3D3'
              : isHalfDay
              ? '#a5f7a5'
              : isSelected
              ? '#28a745'
              : '',
            cursor: (isGray || isBlocked) ? 'not-allowed' : 'pointer',
            minWidth: '80px',
            opacity: isBlocked ? 0.6 : 1,
            border: isBlocked ? '2px dashed #999' : undefined
          }}
        >
          {leaveDays[day] === 1 ? '1' : leaveDays[day] === 0.5 ? '0.5' : ''}
        </td>
      );
    })}
  </tr>
</tbody>

        </table>
    </div>
)}

<div className="actions-row">

<Button 
className="primary-btn"
onClick={isEditMode ? handleUpdate : handleSubmit}
disabled={loading || (monthAlreadyDeclared && !isEditMode)}
>
{isEditMode ? "Valider les modifications" : "Ajouter la déclaration"}
</Button>

<Button 
className="primary-btn"
onClick={() => navigate('/Déclarations', {
  replace: true,
  state: {
    selectedUserId,
    refreshKey: Date.now()
  }
})}
>
Retourner à la liste
</Button>

</div>
{loadingEditView && (
                        <Snackbar
                            open={true}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                            autoHideDuration={null}
                        >
                            <Alert
                                severity="info"
                                sx={{
                                    width: '100%',
                                    fontSize: '1rem',
                                    fontWeight: 'bold',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                Merci de patienter pendant le chargement...
                            </Alert>
                        </Snackbar>
                    )}

{loading && (
  <Snackbar
    open={true}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    autoHideDuration={null}
  >
    <Alert
      severity="info"
      sx={{
        width: '100%',
        fontSize: '1rem',
        fontWeight: 'bold',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      
      Merci de patienter...
    </Alert>
  </Snackbar>
)}

<Snackbar
  open={notification.open}
  autoHideDuration={3000}
  onClose={() => setNotification({ ...notification, open: false })}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert
    severity={notification.severity}
    sx={{
      width: '100%',
      fontSize: '1rem',
      fontWeight: 'bold',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
      borderRadius: '8px',
    }}
  >
    {notification.message}
  </Alert>
</Snackbar>


            </Container>
        </div>
        </LayoutDashboard>

    );
};

export default AjouterDeclarations;
